module.exports = __webpack_public_path__ + "img/14.c20799bb.png";